export const endpoint = 'https://careertrail-oatl.onrender.com'
//export const endpoint = "http://localhost:5000";